import { useEffect } from 'react';

const GoogleReviewsWidget = () => {
  useEffect(() => {
    const scriptId = 'elfsight-platform-script';
    if (!document.getElementById(scriptId)) {
      const script = document.createElement('script');
      script.src = 'https://static.elfsight.com/platform/platform.js';
      script.async = true;
      script.id = scriptId;
      document.body.appendChild(script);
    }
  }, []);

  return (
    <div className="elfsight-app-313568ce-eb8f-49b4-bd59-df8f26ba9950" data-elfsight-app-lazy></div>
  );
};

export default GoogleReviewsWidget;
